module.exports = __webpack_public_path__ + "img/triple_bronze.206ce0d2.svg";